var _linearGradient, _path, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgForm = function SvgForm(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    x2: 512,
    y1: 256,
    y2: 256
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00f38d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009eff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m512 256c0 141.386719-114.613281 256-256 256s-256-114.613281-256-256 114.613281-256 256-256 256 114.613281 256 256zm0 0",
    fill: "url(#a)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m372.140625 269.054688h-232.28125v-81.789063h232.28125zm-202.28125-30h172.28125v-21.789063h-172.28125zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m141.890625 137.34375h228.21875v30h-228.21875zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m245.625 314.832031h124.480469v30h-124.480469zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m221.726562 370.765625h-81.867187v-81.789063h81.867187zm-51.867187-30h21.867187v-21.789063h-21.867187zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m369.007812 424.007812h-226.015624c-30.328126 0-55-24.671874-55-55v-226.015624c0-30.328126 24.671874-55 55-55h226.015624c30.328126 0 55 24.671874 55 55v226.015624c0 30.328126-24.671874 55-55 55zm-226.015624-306.015624c-13.785157 0-25 11.214843-25 25v226.015624c0 13.785157 11.214843 25 25 25h226.015624c13.785157 0 25-11.214843 25-25v-226.015624c0-13.785157-11.214843-25-25-25zm0 0"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgForm, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/form.8591d795.svg";
export { ForwardRef as ReactComponent };